module.exports = __webpack_public_path__ + "img/tm.eb26b0dc.svg";